export default {"src":"/_next/static/media/close_white.52a09c41.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};